import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConsentBanner } from "@/components/ConsentBanner";
import Lenis from "lenis";
import "@/App.css";
import "@/index.css";
import { API } from "@/lib/api";
import Home from "@/pages/Home";
import CalculatorPage from "@/pages/CalculatorPage";
import { PrivacidadPage, MetodologiaPage } from "@/pages/InfoPages";
import { CALCULATORS } from "@/data/calculators";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
          <div>
            <p className="font-serif text-3xl">Algo se rompió por aquí.</p>
            <p className="mt-3 text-muted-foreground">Recarga la página para volver a medirte.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, anchors: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 350);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    fetch(`${API}/`).catch(() => {});
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <div className="grain min-h-screen bg-background text-foreground">
          <Routes>
            <Route path="/" element={<Home />} />
            {CALCULATORS.map((c) => (
              <Route key={c.slug} path={`/${c.slug}`} element={<CalculatorPage slug={c.slug} />} />
            ))}
            <Route path="/privacidad" element={<PrivacidadPage />} />
            <Route path="/metodologia" element={<MetodologiaPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <ConsentBanner />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
